import DesktopContainer from './ImagesContainer/DesktopContainer';

import { Dialog, DialogTitle } from '@mui/material';

const BannerShopDialog = ({
    handleCloseDialog, openDialog,
    type, banner, setBanner,
    deletedImages, setDeletedImages
}) => {
    return (
        <Dialog
            fullWidth
            onClose={handleCloseDialog}
            open={openDialog}
            maxWidth='xl'
            sx={{ zIndex: 1000 }}>
            <DialogTitle>{ `Editar diseño (${type})` }</DialogTitle>
            <DesktopContainer
                banner={ banner }
                setBanner={ setBanner }
                deletedImages={ deletedImages }
                setDeletedImages={ setDeletedImages }
            />
        </Dialog>
    );
};

export default BannerShopDialog;